/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryRoutingModule
 * Purpose		: Routing module for OrdersQry.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OrdersQryListComponent } from './OrdersQryList.component';
import { OrdersQryDetailsComponent } from './OrdersQryDetails.component';

const OrdersQryRoutes: Routes = [
	{ path: 'OrdersQry',  component: OrdersQryListComponent },
	{ path: 'OrdersQry/Details/:id', component: OrdersQryDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(OrdersQryRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class OrdersQryRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrdersQry/OrdersQry-routing.module.ts